import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH, PROJECT_PATH } from '../../url';
const _axios = HttpService.getAxiosClient();

export const getMonthlyPayrollReport = async (
  startDate,
  endDate,
  users,
  columnFilters,
  pageNumber,
  pageSize,
  tabStatus,
) => {
  
  const empStatus = tabStatus === 0 ? "active" : "off-boarded"; 
  try {
    const body = {
      employeeIdList: users,
      columnFilterDTOS: columnFilters,
    };
    let url = `${ADMIN_PATH}/report/timings?startDate=${startDate}&endDate=${endDate}&status=${empStatus}`;
    if (pageSize != -1) {
      url += `&pageSize=${pageSize}&pageNumber=${pageNumber}`;
    }
    const response = await _axios.post(url, body);
    return ErrorSwitchCase(response);
  } catch (error) {
    console.log(error);
    return ErrorSwitchCase(error.response.data);
  }

};

export const getEncashedLeavesReport = async (reportParams) => {

  try {
    let url = `${PROJECT_PATH}/projects/leave-encashments`;
    const response = await _axios.post(url, reportParams);
    return ErrorSwitchCase(response);
    // return { isError: false, data: 1};
  } catch (error) {
    console.log(error);
    return ErrorSwitchCase(error.response.data);
  }

};

export const getHolidaysUtilisationReport = async (reportParams) => {

  try {
    let url;
    url = `${ADMIN_PATH}/report/holidays`;

    const response = await _axios.post(url, reportParams);
    return ErrorSwitchCase(response);
  } catch (error) {
    console.log(error);
    return ErrorSwitchCase(error.response.data);
  }

};
